import React from 'react';
import styled from 'styled-components';
import { BsPlayFill } from 'react-icons/bs';
import { DeviceType } from '@/utils/definitions';

interface PlayAutomationProps {
  device: DeviceType;
  onClick: (ev: React.MouseEvent) => void;
}

export function PlayAutomation({ device, onClick }: PlayAutomationProps) {
  return (
    <PlayAutomationWrapper device={device} onClick={onClick}>
      <BsPlayFill size={18} />
    </PlayAutomationWrapper>
  );
}

const PlayAutomationWrapper = styled.div<{ device: DeviceType }>`
  position: relative;
  height: ${(props) =>
    props.device === DeviceType.Desktop ? `2.5rem` : `3rem`};
  width: ${(props) =>
    props.device === DeviceType.Desktop ? `2.5rem` : `3rem`};
  font-size: ${(props) =>
    props.device === DeviceType.Desktop ? `1.2rem` : `1.4rem`};
  font-weight: bold;
  letter-spacing: 0.47px;
  background-color: #7c7f98;
  color: white;
  opacity: 0.33;
  text-align: center;
  padding-left: 0.2rem;
  border-radius: 50%;

  display: flex;
  align-items: center;
  justify-content: center;

  :hover {
    transform: scale(1.15);
  }

  :active {
    transform: scale(1);
  }

  transition: transform 0.2s ease-in;

  :before {
    content: '';
    display: block;
    height: 125%;
    width: 125%;
    position: absolute;
    border: 1.5px solid #dce1e5;
    border-radius: 50%;
    margin-left: -0.3rem;
  }
`;
